import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import Logo from "@/components/Logo";

export default function MarketingNav() {
  const { user } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-white/70 border-b border-slate-200/60">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
        <Logo />
        <nav className="hidden md:flex items-center gap-8 text-sm font-medium text-brand-muted">
          <Link to="/" className="hover:text-brand-ink transition-colors" data-testid="nav-home">
            Início
          </Link>
          <Link to="/planos" className="hover:text-brand-ink transition-colors" data-testid="nav-planos">
            Planos
          </Link>
          <Link to="/atividades" className="hover:text-brand-ink transition-colors" data-testid="nav-atividades">
            Atividades por Turma
          </Link>
          <Link to="/biblioteca" className="hover:text-brand-ink transition-colors" data-testid="nav-biblioteca">
            Biblioteca de Quizzes
          </Link>
          <a href="/#recursos" className="hover:text-brand-ink transition-colors">
            Recursos
          </a>
        </nav>
        <div className="flex items-center gap-3">
          {user ? (
            <Button
              onClick={() => navigate("/dashboard")}
              className="rounded-full bg-brand-blue hover:bg-blue-700 hover:scale-105 transition-transform"
              data-testid="nav-dashboard-btn"
            >
              Meu painel
            </Button>
          ) : (
            <>
              <Button
                variant="ghost"
                onClick={() => navigate("/login")}
                className="rounded-full hidden sm:inline-flex"
                data-testid="nav-login-btn"
              >
                Entrar
              </Button>
              <Button
                onClick={() => navigate("/cadastro")}
                className="rounded-full bg-brand-blue hover:bg-blue-700 hover:scale-105 transition-transform"
                data-testid="nav-cadastro-btn"
              >
                Começar grátis
              </Button>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
